import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const onboardingGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const scope = authService.getScopeFromToken();

  const isOnCompletarPerfil = state.url.startsWith('/completar-perfil');

  // Redirect to complete profile if scope is onboarding or profile is incomplete
  if ((scope === 'onboarding' || authService.isProfileIncomplete()) && !isOnCompletarPerfil) {
    return router.createUrlTree(['/completar-perfil']);
  }
  return true;
};
